export class TableContextNewNote {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        },
        {
            "name": "date",
            "baseName": "date",
            "type": "string",
            "format": "date"
        },
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextNewNote.attributeTypeMap;
    }
    constructor() {
    }
}
